module.exports = __webpack_public_path__ + "static/media/clement.9b8e924c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionGenius/medias/clement.png
// module id = 231
// module chunks = 0